// -----------------------------------------------------------------------------
// Functions
// -----------------------------------------------------------------------------

/**
 * @notice Normalizes a mail account or recipient email to be lowercase.
 * @param email The email address to normalize.
 * @returns The trimmed, lowercased email address.
 */
export function normalizeEmail(email: string) {
  return email.trim().toLowerCase();
}
